module.exports = __webpack_public_path__ + "img/global.9722fa3.svg";